import styles from '../styles/components/nav.module.css';

import { ReactComponent as ResourcesIcon } from "../assets/components/nav/resources.svg";
import { ReactComponent as AdsIcon } from "../assets/components/nav/ads.svg";
import { ReactComponent as OrdersIcon } from "../assets/components/nav/ordersList.svg";
import { ReactComponent as BonusesIcon } from "../assets/components/nav/bonuses.svg";
import { ReactComponent as SubListIcon } from "../assets/components/nav/subList.svg";
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { appStore } from '../stores';


interface ComponentProps {
    activePage: number;
};


export default function Nav({activePage}: ComponentProps) {
    const tg = window.Telegram.WebApp;
    const navigate = useNavigate();
    const [dayPromoCodeTime, setDayPromoCodeTime] = useState(0);

    const handleNavigate = (path: string) => {
        tg.HapticFeedback.impactOccurred("heavy");
        navigate(path, { replace: true });
    };

    const updateDayPromoCodeTime = () => {
        const endDayPromoCodeTime = moment.unix(appStore.dayPromoCode.from_unix).add(20, 'minutes');
        const durationPromoCode = moment.duration(endDayPromoCodeTime.diff(moment()));
    
        setDayPromoCodeTime(durationPromoCode.asMilliseconds());
        return durationPromoCode.asMilliseconds();
    }
    
    useEffect(() => {
    if (appStore.dayPromoCode) {
        const duration = updateDayPromoCodeTime();
        
        if (duration <= 0) {
        return;
        }

        const interval = setInterval(() => {
        const duration = updateDayPromoCodeTime();
        
        if (duration <= 0) {
            clearInterval(interval);
        }
        }, 500);
    
        return () => clearInterval(interval);
    }
    }, [appStore.dayPromoCode]);

    return <div className={styles.nav}>
        {activePage === 1 && <div className={styles.sub_pages}>
            <button className={activePage === 1 ? styles.sub_page_button__active : styles.sub_page_button}><SubListIcon/>В списке</button>
        </div>}
        <div className={styles.base_pages}>
            <div className={activePage === 1 ? styles.page_button__active : styles.page_button} onClick={() => handleNavigate('/offers')}><AdsIcon/>Реклама</div>
            <div className={activePage === 2 ? styles.page_button__active : styles.page_button} onClick={() => handleNavigate('/tasks')}><BonusesIcon/>Бонусы{activePage !== 2 && appStore.dayPromoCode.from_unix && !appStore.dayPromoCode.promo_code_used && dayPromoCodeTime > 0 && <span className={styles.timer}>{moment.utc(dayPromoCodeTime).format("mm:ss")}</span>}</div>
            <div className={activePage === 3 ? styles.page_button__active : styles.page_button} onClick={() => handleNavigate('/channels')}><ResourcesIcon/>Ресурсы</div>
            <div className={activePage === 4 ? styles.page_button__active : styles.page_button} onClick={() => handleNavigate('/orders')}><OrdersIcon/>Заказы</div>
        </div>
    </div>;
};